import * as Mutation from './mutation-types'

export default {
  [Mutation.DELETE_TASK]() {
  },
  [Mutation.CHANGE_DAY_TASKS_STATUS](state, {agenda, eventDayId, scheduleId, status}) {
    const newAgenda = agenda

    const scheduleIndex = newAgenda.findIndex(schedule => schedule.id === scheduleId)

    if (scheduleIndex !== -1) {
      const eventDayIndex = newAgenda[scheduleIndex].eventos_agenda.findIndex(event => event.id === eventDayId)

      if (eventDayIndex !== -1) {
        const courses = newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos

        courses.forEach(course => {
          course.modulos.forEach(module => {
            module.tarefas.forEach(task => {
              task.concluido = status ? 1 : 0
            })
          })
        })
      }
    }

    return agenda = newAgenda
  },

  [Mutation.CHANGE_TASK_STATUS](state, {agenda, courseId, eventDayId, scheduleId, status, taskId}) {
    const newAgenda = agenda

    const scheduleIndex = newAgenda.findIndex(schedule => schedule.id === scheduleId)

    if (scheduleIndex !== -1) {
      const eventDayIndex = newAgenda[scheduleIndex].eventos_agenda.findIndex(event => event.id === eventDayId)

      if (eventDayIndex !== -1) {
        const courseIndex = newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos.findIndex(course => {
          return course.id === courseId
        })

        if (courseIndex !== -1) {
          let taskIndex
          const moduleIndex = newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos[courseIndex].modulos
            .findIndex(module => {
              taskIndex = module.tarefas.findIndex(task => task.id === taskId)
              return taskIndex !== -1
            })

          if (moduleIndex !== -1) {
            newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos[courseIndex].modulos[moduleIndex]
              .tarefas[taskIndex].concluido = status ? 1 : 0
          }
        }
      }
    }

    return agenda = newAgenda
  },

  [Mutation.LOAD_TASKS_STATUS_CHANGES](state, agenda) {
    const {eventDayId, scheduleId, tasks} = state.changes
    const newAgenda = agenda

    const scheduleIndex = newAgenda.findIndex(schedule => schedule.id === scheduleId)

    if (scheduleIndex !== -1) {
      const eventDayIndex = newAgenda[scheduleIndex].eventos_agenda.findIndex(event => event.id === eventDayId)

      if (eventDayIndex !== -1) {
        const courses = newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos

        courses.forEach(course => {
          course.modulos.forEach(module => {
            module.tarefas.forEach(task => {
              const changedTask = tasks.find(({id}) => id === task.id)

              if (changedTask) {
                task.concluido = changedTask.status ? 1 : 0
              }
            })
          })
        })

        newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos = courses
      }
    }

    return agenda = newAgenda
  },

  [Mutation.REMOVE_EVENT_DAY_COURSES](state, {agenda, courseIds, eventDayId}) {
    const newAgenda = agenda
    let eventDayIndex
    const scheduleIndex = newAgenda.findIndex(schedule => {
      eventDayIndex = schedule.eventos_agenda.findIndex(event => event.id === eventDayId)
      return eventDayIndex !== -1
    })

    if (scheduleIndex !== -1) {
      newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos =
        newAgenda[scheduleIndex].eventos_agenda[eventDayIndex].cursos.filter(course => !courseIds.includes(course.id))
    }

    return agenda = newAgenda
  },

  [Mutation.RESET_DAY_TASKS_CHANGES](state) {
    return state.changes = {
      eventDayId: null,
      scheduleId: null,
      tasks: []
    }
  },

  [Mutation.SET_TASK_API_ERROR](state, error) {
    return state.taskApiError = error
  },

  [Mutation.STORE_TASK_STATUS_CHANGE](state, {eventDayId, scheduleId, status, taskId}) {
    const changes = state.changes

    changes.eventDayId = changes.eventDayId ?? eventDayId
    changes.scheduleId = changes.scheduleId ?? scheduleId

    const taskIndex = changes.tasks.findIndex(task => task.id === taskId)
    if (taskIndex !== -1) {
      changes.tasks[taskIndex].status = status
    } else {
      changes.tasks.push({id: taskId, status})
    }

    return state.changes = changes
  }
}
